export const dailyWeatherConditionsTestIDs = {
  headerText: 'daily_weather_forecast_tile_header_text',
  today: 'daily_weather_forecast_tile_today',
  tomorrow: 'daily_weather_forecast_tile_tomorrow',
  dayAfterTomorrow: 'daily_weather_forecast_tile_day_after_tomorrow',
};
